'use strict';

/*global Bloodhound*/

(function ($) {
  var methods = {
    init: function (options) {
      // options are not used
      var opts = $.extend({}, $.fn.k2_labels.defaults, options);
      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('labels-init')) {
          return;
        }

        $this.addClass('labels-init');

        if ($this.data('typeahead')) {
          var labels = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.whitespace,
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            local: $this.data('typeahead').split(',')
          });
          labels.initialize();

          opts.typeaheadjs = {
            name: 'labels',
            source: labels.ttAdapter()
          };
        }

        if ($this.data('freeinput')) {
          opts.freeInput = true;
        }

        if ($this.data('allow_duplicates')) {
          opts.allowDuplicates = true;
        }

        $this.find('.label-input').tagsinput(opts);

        $this.on('click', '.labels-container .label', function () {
          $this.find('.label-input').tagsinput('add', $(this).text());
        });
      });
    },
  };

  $.fn.k2_labels = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_labels');
    }

  };

  $.fn.k2_labels.defaults = {};

})(jQuery);
